import { defineMessages } from 'react-intl'

export default defineMessages({
  editorDisabled: {
    id: 'editor.disabled',
    defaultMessage: 'Editor nije moguće pokrenuti na ovoj veličini ekrana',
  },
})
